import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

const checkErroreSimulatoreSconti = (appartamento, start, end) => {
    let trovatoErrore = { valore: false }

    if (moment(start).isSameOrAfter(moment(end))) {
        trovatoErrore = {
            valore: true,
            message: "Hai inserito una data di partenza precedente alla data di arrivo!"
        }
    }

    if (appartamento == "") {
        trovatoErrore = {
            valore: true,
            message: "Non hai inserito nessun appartamento!"
        }
    }

    if (start == "") {
        trovatoErrore = {
            valore: true,
            message: "Non hai inserito nessuna data di arrivo!"
        }
    }

    if (end == "") {
        trovatoErrore = {
            valore: true,
            message: "Non hai inserito nessuna data di partenza!"
        }
    }

    return trovatoErrore

}

const checkErrorePeriodoSconto = (periodo) => {

    let regexNomePeriodo = /^[a-zA-Z\s]+$/;
    let trovatoErrore = { valore: false }

    if (periodo.anno === "") {
        trovatoErrore = {
            valore: true,
            message: "Non hai selezionato nessun anno"
        }
    }
    if (!regexNomePeriodo.test(periodo.title)) {
        trovatoErrore = {
            valore: true,
            message: "Il nome non può essere vuoto e non deve contenere carattere speciali o numeri"
        }
    }

    if (periodo.durata_4_6 == undefined) {
        trovatoErrore = {
            valore: true,
            message: "Inserire uno sconto per il periodo 4-6 giorni!"
        }
    }

    if (periodo.durata_6_14 == undefined) {
        trovatoErrore = {
            valore: true,
            message: "Inserire uno sconto per il periodo di una settimana!"
        }
    }

    if (periodo.durata_14_28 == undefined) {
        trovatoErrore = {
            valore: true,
            message: "Inserire uno sconto per il periodo di due settimane!"
        }
    }

    if (periodo.durata_28 == undefined) {
        trovatoErrore = {
            valore: true,
            message: "Inserire uno sconto per il periodo maggiore di 28 giorni!"
        }
    }

    return trovatoErrore
}

const colorWeekend = (schedulerData) => {
    schedulerData.headers.map((header) => {
        console.log(moment(header.time).format('dddd, D MMMM YYYY'))
        header['nonWorkingTime'] = false
        if (moment(header.time).format('dddd, D MMMM YYYY').includes('sabato') ||
            moment(header.time).format('dddd, D MMMM YYYY').includes('domenica')
        ) {
            header['nonWorkingTime'] = true
        }
    })
    return schedulerData
}

const buildPrenotazioneBody = (prenotazione, prenotazioneID, rooms, stato) => {

    console.log("prenotazione", prenotazione)
    console.log("prenotazione.start", prenotazione.start)
    console.log("prenotazione.start dopo moment", moment(prenotazione.start).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).utc().unix() * 1000)

    let start = moment(prenotazione.start).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).utc().unix() * 1000
    let end = moment(prenotazione.end).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).add(-1, 'days').utc().unix() * 1000;

    console.log("start", start)
    console.log("end", end)

    let prenotazioneBody = {
        id: prenotazioneID,
        title: prenotazione.nome + " " + prenotazione.cognome,
        start: start,
        end: end,
        nome: prenotazione.nome,
        cognome: prenotazione.cognome,
        mail: prenotazione.mail,
        bgColor: prenotazione.bgColor,
        checkin: prenotazione.checkin,
        checkout: prenotazione.checkout,
        resourceId: prenotazione.resourceId,
        numeroAdulti: prenotazione.numeroAdulti,
        numeroBambini: prenotazione.numeroBambini,
        telefono: prenotazione.telefono,
        acconto: prenotazione.acconto,
        pagamento: prenotazione.pagamento,
        noteBestHouse: prenotazione.noteBestHouse,
        noteCliente: prenotazione.noteCliente,
        stato: prenotazione.stato,
        servizi: prenotazione.servizi,
        prezzo: prenotazione.prezzo,
        movable: false,
        resizable: false,
        showPopover: true,
        timestamp: moment(new Date()).utc().unix() * 1000
    }

    console.log("prenotazioneBody", prenotazioneBody)


    if (prenotazione.stato === "NON_APPROVATA") {
        if (Object.keys(prenotazioneBody.servizi).length === 0) {
            rooms.map((room) => {
                if (prenotazioneBody['resourceId'] === room['id']) {
                    room.servizi.map((x) => {
                        if (x['isPagamento'] === true) {
                            prenotazioneBody['servizi'][x['servizio']] = false
                        }
                    })
                }
            })
        }
    }

    if (stato === "CANCELLATA") {
        prenotazioneBody['stato'] = "CANCELLATA"
    }

    return prenotazioneBody

}

const buildNewPrenotazione = (start, end, roomId) => {

    let newIDPrenotazione = uuidv4()

    let newPrenotazione = {
        id: newIDPrenotazione,
        start: start === '' ? '' : moment(start).format('YYYY-MM-DD'),
        end: end === '' ? '' : moment(end).format('YYYY-MM-DD'),
        resourceId: roomId,
        nome: '',
        cognome: '',
        mail: '',
        numeroAdulti: 0,
        numeroBambini: 0,
        telefono: 0,
        prezzo: 0,
        checkin: moment(new Date()).set({ hour: 16, minute: 0, second: 0, millisecond: 0 }).format('HH:mm'),
        checkout: moment(new Date()).set({ hour: 10, minute: 0, second: 0, millisecond: 0 }).format('HH:mm'),
        bgColor: 'red',
        servizi: {},
        acconto: 0,
        pagamento: '',
        noteBestHouse: '',
        noteCliente: '',
        stato: "NON_APPROVATA"
    }

    return newPrenotazione
}

export {
    checkErrorePeriodoSconto,
    buildPrenotazioneBody,
    buildNewPrenotazione,
    colorWeekend,
    checkErroreSimulatoreSconti
}
